import I18n from "i18n-js";
import { fetch } from "../../../appContainer";
import {
  GET_THERMOMETERS_LIST_IN_PROGRESS,
  GET_THERMOMETERS_LIST_SUCCESS,
  GET_THERMOMETERS_LIST_FAIL,
  GET_THERMOMETER_INFOS_IN_PROGRESS,
  GET_THERMOMETER_INFOS_SUCCESS,
  GET_THERMOMETER_INFOS_FAIL,
  POST_THERMOMETER_IN_PROGRESS,
  POST_THERMOMETER_SUCCESS,
  POST_THERMOMETER_FAIL,
  PUT_THERMOMETER_IN_PROGRESS,
  PUT_THERMOMETER_SUCCESS,
  PUT_THERMOMETER_FAIL,
  DELETE_THERMOMETER_IN_PROGRESS,
  DELETE_THERMOMETER_SUCCESS,
  DELETE_THERMOMETER_FAIL,
} from "../constants";
import { SUBMIT_SUCCESS, SUBMIT_FAIL } from "../../common/constants";

/**
 * Create thermometer
 *
 * @param {Object} thermometer
 */
export function createThermometer(thermometer) {
  return (dispatch) => {
    dispatch({ type: POST_THERMOMETER_IN_PROGRESS });

    fetch("api").createThermometer(
      thermometer,
      () => {
        const message = I18n.t("alerts.add:thermometer.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({ type: POST_THERMOMETER_SUCCESS });
      },
      (error) => {
        let message = I18n.t("alerts.common.fail");
        if (error.violations?.length) {
          message = I18n.t(
            `alerts.add:thermometer.fail:${error.violations[0].path}`,
          );
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({
          type: POST_THERMOMETER_FAIL,
          payload: { violations: error.violations },
        });
      },
    );
  };
}

/**
 * Update thermometer
 *
 * @param {String} uuid
 * @param {Object} thermometer
 */
export function updateThermometer(uuid, thermometer) {
  return (dispatch) => {
    dispatch({ type: PUT_THERMOMETER_IN_PROGRESS });

    fetch("api").updateThermometer(
      uuid,
      thermometer,
      () => {
        const message = I18n.t("alerts.update:thermometer.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch({ type: PUT_THERMOMETER_SUCCESS });
      },
      (error) => {
        let message = I18n.t("alerts.common.fail");
        if (error.violations?.length) {
          message = I18n.t(
            `alerts.update:thermometer.fail:${error.violations[0].path}`,
          );
        }

        dispatch({ type: SUBMIT_FAIL, payload: { message } });
        dispatch({
          type: PUT_THERMOMETER_FAIL,
          payload: { violations: error.violations },
        });
      },
    );
  };
}

/**
 * Get thermometers list
 */
export function getThermometersList() {
  return (dispatch) => {
    dispatch({ type: GET_THERMOMETERS_LIST_IN_PROGRESS });

    fetch("api").getThermometersList(
      (list) => {
        dispatch({ type: GET_THERMOMETERS_LIST_SUCCESS, payload: { list } });
      },
      () => dispatch({ type: GET_THERMOMETERS_LIST_FAIL }),
    );
  };
}

/**
 * Delete thermometer
 *
 * @param {String} uuid
 */
export function deleteThermometer(uuid) {
  return (dispatch) => {
    dispatch({ type: DELETE_THERMOMETER_IN_PROGRESS });

    fetch("api").deleteThermometer(
      uuid,
      () => {
        const message = I18n.t("alerts.delete:thermometer.success");

        dispatch({ type: SUBMIT_SUCCESS, payload: { message } });
        dispatch(getThermometersList());
        dispatch({ type: DELETE_THERMOMETER_SUCCESS });
      },
      () => {
        const message = I18n.t("alerts.delete:thermometer.fail");

        dispatch({ type: DELETE_THERMOMETER_FAIL });
        dispatch({ type: SUBMIT_FAIL, payload: { message } });
      },
    );
  };
}

/**
 * Get thermometer infos
 */
export function getThermometerInfos(uuid) {
  return (dispatch) => {
    dispatch({ type: GET_THERMOMETER_INFOS_IN_PROGRESS });

    fetch("api").getThermometerInfos(
      uuid,
      (infos) => {
        dispatch({ type: GET_THERMOMETER_INFOS_SUCCESS, payload: { infos } });
      },
      () => dispatch({ type: GET_THERMOMETER_INFOS_FAIL }),
    );
  };
}
